import { render } from "./FootLinks.vue?vue&type=template&id=923a8fd2&scoped=true&ts=true"
import script from "./FootLinks.vue?vue&type=script&lang=ts"
export * from "./FootLinks.vue?vue&type=script&lang=ts"

import "./FootLinks.vue?vue&type=style&index=0&id=923a8fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923a8fd2"]])

export default __exports__